import React from "react";
import { useState } from "react";

import {
  BsFillCameraVideoFill,
  BsFillCameraVideoOffFill,
  BsFillMicFill,
  BsFillMicMuteFill,
} from "react-icons/bs";
import { BiPhoneOff } from "react-icons/bi";
import vediocallimg from "../asset/vediocallasset.jpeg";

import { ChatState } from "../asset/context";

function Lobby(props) {
  const { userVideo, stream, myVideo, leaveCall } = ChatState();
  const [cameraOn, setCameraOn] = useState(true);
  const [micOn, setMicOn] = useState(false);
  const [allUsers, setAllusers] = useState([]);

  const offMicrophone = () => {
    stream.getAudioTracks()[0].enabled = !stream.getAudioTracks()[0].enabled;
    setMicOn((r) => (r === false ? true : false));
  };
  function muteVideo() {
    if (stream && stream.getVideoTracks().length > 0) {
      if (stream.getVideoTracks()[0].enabled === false) {
        stream.getVideoTracks()[0].enabled = true;
        setCameraOn(true);
      } else {
        stream.getVideoTracks()[0].enabled = false;
        setCameraOn(false);
      }
    }
  }

  return (
    <>
      <div
        className="lobby_main_box"
        style={{ display: props.display, zIndex: "+100" }}
      >
        <div className="lobby_activeUsers">
          <div className="lobby_activeuser_head">
            <h2>Participants</h2>
            <span>{allUsers.length}</span>
          </div>
          {/* {allUsers.map((user) => {
            return (
              <div className="activeusers" key={user._id}>
                <img src={vediocallimg} alt="foto" />
                <h3>{user.fullname}</h3>
                {checkOnlineStatus(user) ? (
                  <FcVideoCall onClick={() => CallUser(user)} />
                ) : (
                  ""
                )}
              </div>
            );
          })} */}
        </div>

        <div className="lobby_me">
          <div className="lobby_my_camera">
            <video
              playsInline
              ref={myVideo}
              autoPlay
              muted="true"
              id="me"
              poster={vediocallimg}
              style={{ display: "block" }}
            />
            <video
              playsInline
              id="friend"
              ref={userVideo}
              autoPlay
              poster={vediocallimg}
            />
          </div>
          <div className="lobby_join">
            <button onClick={offMicrophone}>
              {micOn ? (
                <BsFillMicMuteFill style={{ color: "crimson" }} />
              ) : (
                <BsFillMicFill />
              )}
            </button>
            <button onClick={muteVideo}>
              {cameraOn ? (
                <BsFillCameraVideoFill />
              ) : (
                <BsFillCameraVideoOffFill style={{ color: "crimson" }} />
              )}
            </button>
            <button onClick={leaveCall}>{<BiPhoneOff />}</button>
          </div>
        </div>
        <div className="lobby_chats">
          <form className="lobby_chats_input">
            <input type="text" placeholder="Send a message..." />
          </form>
        </div>
      </div>
    </>
  );
}

export default Lobby;
